import { lazyNamed } from 'src/utils/lazyNamed.ts';
import InventoryManagement from './pages/InventoryManagementSection/index.tsx';

export const AnalogOperations = {
  CampaignManagement: lazyNamed(() => import('./pages/CampaignManagement/index.tsx'), 'CampaignManagement'),
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  InventoryManagement,
};
